import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPackages } from '../../store/slices/packageSlice';

const PackagesPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { packages, loading } = useSelector((state) => state.packages);

  useEffect(() => {
    dispatch(fetchPackages());
  }, [dispatch]);

  return (
    <Container maxWidth="xl">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Packages
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/packages/new')}
        >
          Add Package
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
                <TableRow>
                  <TableCell width={56}>#</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Base Price</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
              {packages.map((pkg, index) => (
                <TableRow key={pkg.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{pkg.name}</TableCell>
                  <TableCell>{pkg.duration} days</TableCell>
                  <TableCell>
                    {pkg.currency === 'PKR' || /pakistan|swat|hunza|skardu|murree|lahore|naran/i.test(pkg.name || '')
                      ? `PKR ${Number(pkg.basePrice).toLocaleString()}`
                      : `${pkg.currency || '$'}${pkg.currency ? ' ' : ''}${Number(pkg.basePrice).toLocaleString()}`}
                  </TableCell>
                  <TableCell>{pkg.status}</TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      onClick={() => navigate(`/packages/${pkg.id}`)}
                    >
                      View
                    </Button>
                    <Button
                      size="small"
                      onClick={() => navigate(`/packages/${pkg.id}/edit`)}
                      sx={{ ml: 1 }}
                    >
                      Edit
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default PackagesPage;

